<template>
  <div class="roll-winning">
    <div
      class="winning-member"
      :class="{ anim: animate && index == 0 }"
      v-for="(item, index) in wins"
      :key="index"
    >
      <div class="avart">
        <img
          :src="
            item.headImgUrl ? item.headImgUrl : require('@/assets/user.png')
          "
          alt
        />
      </div>
      <div class="text">
        {{ item.nickName | filterName }}已获得{{ item.prizeName }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RollWins",
  props: {
    wins: {
      type: Array,
    },
  },
  data() {
    return {
      animate: false,
    };
  },
  filters: {
    filterName: function (name) {
      if (name == null) {
        return "***";
      } else if (name && name.length >= 1) {
        return name.slice(0, 2) + "***";
      } else {
        return name + "***";
      }
    },
  },
  created() {
    this.inter = setInterval(this.scroll, 2000); // 开启滚动中奖用户
  },
  beforeDestroy() {
    clearInterval(this.inter);
  },
  methods: {
    scroll() {
      this.animate = true;
      setTimeout(() => {
        this.wins.push(this.wins[0]);
        this.wins.shift();
        this.animate = false;
      }, 1000);
    },
  },
};
</script>

<style scoped>
.roll-winning {
  height: 100%;
  overflow: hidden;
  position: relative;
  left: 0;
  right: 0;
  /* bottom: 120px; */
  /* z-index: 999; */
}

.anim {
  transition: all 1s;
  margin-top: -30px;
}

.roll-winning .winning-member {
  /* height: 32px; */
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 12px;
  width: 100%;
  height: 100%;
  
}
.roll-winning .winning-member .avart {
  width: 24px;
  height: 24px;
  border-radius: 100%;
  overflow: hidden;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
}
.roll-winning .winning-member .avart > img {
  width: 100%;
  height: 100%;
}

.roll-winning .winning-member .text {
  /* line-height: 20px;
  padding: 5px 15px;
  border-radius: 20px; */
  font-size: 12px;
  color: #fff;
  /* background: rgba(0, 0, 0, 0.5); */
  margin-left: 10px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>